import React from "react";

const EditProfileIcn = (props) => {
  return (
    <svg viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.99979 9.71014C6.43949 9.71014 4.36157 7.62692 4.36157 5.07193C4.36157 2.51693 6.4448 0.428406 8.99979 0.428406C11.5548 0.428406 13.638 2.51163 13.638 5.06662C13.638 7.62162 11.5548 9.70484 8.99979 9.70484V9.71014ZM8.99979 1.62109C7.0968 1.62109 5.55426 3.16893 5.55426 5.06662C5.55426 6.96432 7.1021 8.51216 8.99979 8.51216C10.8975 8.51216 12.4453 6.96432 12.4453 5.06662C12.4453 3.16893 10.8975 1.62109 8.99979 1.62109Z"
        fill={props.color}
        stroke={props.color}
        strokeWidth="0.4"
      />
      <path
        d="M16.9774 18.158H1.02191C0.693264 18.158 0.428223 17.893 0.428223 17.5643C0.428223 13.7053 4.27662 10.5672 8.99965 10.5672C13.7227 10.5672 17.5711 13.7053 17.5711 17.5643C17.5711 17.893 17.306 18.158 16.9774 18.158ZM1.65801 16.9653H16.3413C15.9596 14.0446 12.8109 11.7599 8.99965 11.7599C5.18836 11.7599 2.03967 14.0446 1.65801 16.9653Z"
        fill={props.color}
        stroke={props.color}
        strokeWidth="0.4"
      />
    </svg>
  );
};

export default EditProfileIcn;
